
export enum SpecialEquipmentCd {
	FORKLIFT = 'Forklift',
	LIFTGATE = 'Liftgate',
	PALLET_JACK = 'PalletJack',
	UNDEFINED = 'Undefined'}

